export default {
  status: 'number',
  paddle_number: 'number',
  amount: 'number',
  user_id: 'number'
}



// WEBPACK FOOTER //
// ./src/store/models/engagement.js